import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getPersonalProtectiveEquipmentList as getPersonalProtectiveEquipmentListApi,
	getPersonalProtectiveEquipmentQuery as getPersonalProtectiveEquipmentQueryApi,
	getPersonalProtectiveEquipment as getPersonalProtectiveEquipmentApi,
	addNewPersonalProtectiveEquipment as addNewPersonalProtectiveEquipmentApi,
	updatePersonalProtectiveEquipment as updatePersonalProtectiveEquipmentApi,
	updatePersonalProtectiveEquipmentDocument as updatePersonalProtectiveEquipmentDocumentApi,
	deletePersonalProtectiveEquipment as deletePersonalProtectiveEquipmentApi,
	setPersonalProtectiveEquipmentCancelled as setPersonalProtectiveEquipmentCancelledApi,
	setPersonalProtectiveEquipmentDelivered as setPersonalProtectiveEquipmentDeliveredApi,
	setPersonalProtectiveEquipmentPicked as setPersonalProtectiveEquipmentPickedApi,
	getPersonalProtectiveEquipmentStatusByCode as getPersonalProtectiveEquipmentStatusByCodeApi,
	getPersonalProtectiveEquipmentStatusList as getPersonalProtectiveEquipmentStatusListApi,
	getPersonalProtectiveEquipmentReasonList as getPersonalProtectiveEquipmentReasonListApi,
	getDashboardStatus as getDashboardStatusApi,
	getDashboardReason as getDashboardReasonApi,
	getDashboardEstablishment as getDashboardEstablishmentApi,
	getDashboardCompany as getDashboardCompanyApi,
	getAssignedItemsList as getAssignedItemsListApi,
	getPersonAssignedItemsSummary as getPersonAssignedItemsSummaryApi,
	getPersonAssignedItemsSummaryQuery as getPersonAssignedItemsSummaryQueryApi,
	getPersonAssignedItemsSummaryAll as getPersonAssignedItemsSummaryAllApi,
	getWarehouseAssignedItemsSummary as getWarehouseAssignedItemsSummaryApi,
	getWarehouseAssignedItemsSummaryQuery as getWarehouseAssignedItemsSummaryQueryApi,
	getCostPPEByEstablishment as getCostPPEByEstablishmentApi,
	getPersonAssignmentsQuery as getPersonAssignmentsQueryApi,
	getPersonAssignmentItemsQuery as getPersonAssignmentItemsQueryApi
} from '../../helpers/warehouse/backend_helper';

export const getPersonalProtectiveEquipmentList = createAsyncThunk('personalProtectiveEquipment/getPersonalProtectiveEquipmentList', async params => {
	try {
		const response = getPersonalProtectiveEquipmentListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);

export const getPersonalProtectiveEquipmentQuery = createAsyncThunk('personalProtectiveEquipment/getPersonalProtectiveEquipmentQuery', async params => {
	try {
		const response = getPersonalProtectiveEquipmentQueryApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);


export const getPersonalProtectiveEquipment = createAsyncThunk('personalProtectiveEquipment/getPersonalProtectiveEquipment', async personal_protective_equipment_id => {
	try {
		const response = getPersonalProtectiveEquipmentApi(personal_protective_equipment_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);

export const getPersonalProtectiveEquipmentByPersonId = createAsyncThunk('personalProtectiveEquipment/getPersonalProtectiveEquipmentByPersonId', async params => {
	try {
		const response = getPersonalProtectiveEquipmentListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);

export const addNewPersonalProtectiveEquipment = createAsyncThunk('personalProtectiveEquipment/addNewPersonalProtectiveEquipment', async personal_protective_equipment => {
	try {
		const response = addNewPersonalProtectiveEquipmentApi(personal_protective_equipment);
		toast.success('Equipamiento de Protección Personal agregado exitosamente.', {
			autoClose: 3000,
		});
		return response;
	} catch (error) {
		toast.error('Error al agregar personal_protective_equipment.', { autoClose: 3000 });
		throw new Error(error);
	}
}
);

export const updatePersonalProtectiveEquipment = createAsyncThunk('personalProtectiveEquipment/updatePersonalProtectiveEquipment', async personal_protective_equipment => {
	try {
		const response = updatePersonalProtectiveEquipmentApi(personal_protective_equipment);
		if (!personal_protective_equipment.pick_person_id) {
			toast.success('Equipamiento de Protección Personal actualizado exitosamente', {
				autoClose: 3000,
			});
		}
		return response;
	} catch (error) {
		toast.error('Error al actualizar personal_protective_equipment.', {
			autoClose: 3000,
		});
		throw new Error(error);
	}
}
);

export const updatePersonalProtectiveEquipmentDocument = createAsyncThunk(
	'personalProtectiveEquipment/updatePersonalProtectiveEquipmentDocument',
	async personal_protective_equipment => {
		try {
			const response = await
				updatePersonalProtectiveEquipmentDocumentApi(
					personal_protective_equipment
				);

			toast.success(
				'Documento de Equipamiento de Protección Personal actualizado exitosamente',
				{
					autoClose: 3000,
				}
			);

			return response;
		} catch (error) {
			toast.error(
				'Error al actualizar documento de personal_protective_equipment.',
				{
					autoClose: 3000,
				}
			);

			throw new Error(error);
		}
	}
);

export const deletePersonalProtectiveEquipment = createAsyncThunk('personalProtectiveEquipment/deletePersonalProtectiveEquipment', async personal_protective_equipment => {
	try {
		const response = await deletePersonalProtectiveEquipmentApi(personal_protective_equipment);
		toast.success('Equipamiento de Protección Personal eliminado exitosamente.', {
			autoClose: 3000,
		});
		return { personal_protective_equipment, ...response };
	} catch (error) {
		toast.error('Error al eliminar personal_protective_equipment.', {
			autoClose: 3000,
		});
		throw new Error(error);
	}
}
);

export const setPersonalProtectiveEquipmentCancelled = createAsyncThunk('personalProtectiveEquipment/setPersonalProtectiveEquipmentCancelled', async personal_protective_equipment_id => {
	try {
		const response = setPersonalProtectiveEquipmentCancelledApi(personal_protective_equipment_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const setPersonalProtectiveEquipmentDelivered = createAsyncThunk('personalProtectiveEquipment/setPersonalProtectiveEquipmentDelivered', async personal_protective_equipment_id => {
	try {
		const response = setPersonalProtectiveEquipmentDeliveredApi(personal_protective_equipment_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const setPersonalProtectiveEquipmentPicked = createAsyncThunk('personalProtectiveEquipment/setPersonalProtectiveEquipmentPicked', async personal_protective_equipment => {
	try {
		const response = setPersonalProtectiveEquipmentPickedApi(personal_protective_equipment);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getPersonalProtectiveEquipmentStatusByCode = createAsyncThunk('personalProtectiveEquipment/getPersonalProtectiveEquipmentStatusByCode', async code => {
	try {
		const response = getPersonalProtectiveEquipmentStatusByCodeApi(code);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);

export const getPersonalProtectiveEquipmentReasonList = createAsyncThunk('personalProtectiveEquipment/getPersonalProtectiveEquipmentReasonList', async () => {
	try {
		const response = getPersonalProtectiveEquipmentReasonListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);


//CONTROL

export const getPersonAssignedItemsSummary = createAsyncThunk('personalProtectiveEquipment/getPersonAssignedItemsSummary', async params => {
	try {
		const response = getPersonAssignedItemsSummaryApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);

export const getPersonAssignedItemsSummaryQuery = createAsyncThunk('personalProtectiveEquipment/getPersonAssignedItemsSummaryQuery', async params => {
	try {
		const response = getPersonAssignedItemsSummaryQueryApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);

export const getPersonAssignmentsQuery = createAsyncThunk('personalProtectiveEquipment/getPersonAssignmentsQuery', async params => {
	try {
		const response = getPersonAssignmentsQueryApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);

export const getPersonAssignmentItemsQuery = createAsyncThunk('personalProtectiveEquipment/getPersonAssignmentItemsQuery', async params => {
	try {
		const response = getPersonAssignmentItemsQueryApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);

export const getPersonAssignedItemsSummaryAll = createAsyncThunk('personalProtectiveEquipment/getPersonAssignedItemsSummaryAll', async params => {
	try {
		const response = getPersonAssignedItemsSummaryAllApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);


export const getWarehouseAssignedItemsSummary = createAsyncThunk('personalProtectiveEquipment/getWarehouseAssignedItemsSummary', async params => {
	try {
		const response = getWarehouseAssignedItemsSummaryApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);

export const getWarehouseAssignedItemsSummaryQuery = createAsyncThunk('personalProtectiveEquipment/getWarehouseAssignedItemsSummaryQuery', async params => {
	try {
		const response = getWarehouseAssignedItemsSummaryQueryApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);


//DASHBOARD



export const getDashboardStatus = createAsyncThunk('personalProtectiveEquipment/getDashboardStatus', async params => {
	try {
		const response = getDashboardStatusApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);

export const getDashboardReason = createAsyncThunk('personalProtectiveEquipment/getDashboardReason', async params => {
	try {
		const response = getDashboardReasonApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);

export const getDashboardEstablishment = createAsyncThunk('personalProtectiveEquipment/getDashboardEstablishment', async params => {
	try {
		const response = getDashboardEstablishmentApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);

export const getDashboardCompany = createAsyncThunk('personalProtectiveEquipment/getDashboardCompany', async params => {
	try {
		const response = getDashboardCompanyApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);


export const getAssignedItemsList = createAsyncThunk('personalProtectiveEquipment/getAssignedItemsList', async params => {
	try {
		const response = getAssignedItemsListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);

export const getPersonalProtectiveEquipmentStatusDefaultRegularization = createAsyncThunk('personalProtectiveEquipment/getPersonalProtectiveEquipmentStatusDefaultRegularization', async code => {
	try {
		const response = getPersonalProtectiveEquipmentStatusListApi(code);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
);

export const getCostPPEByEstablishment = createAsyncThunk(
    'personalProtectiveEquipment/getCostPPEByEstablishment',
    async ({ establishment_id, filter, group, company_id }) => {
        try {
            const response = await getCostPPEByEstablishmentApi({
                establishment_id,
                filter,
                group,
                company_id,
            });
            return response;
        } catch (error) {
            throw new Error(error);
        }
    }
);
